/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Seo_Q_CostInputs */

const en_seo_q_cost = /** @type {(inputs: Seo_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How much does the ${i?.name} API cost?`)
};

const zh_hans1_seo_q_cost = /** @type {(inputs: Seo_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} API 怎么收费？`)
};

const pt_br2_seo_q_cost = /** @type {(inputs: Seo_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quanto custa a API para ${i?.name}?`)
};

const es_seo_q_cost = /** @type {(inputs: Seo_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`¿Cuánto cuesta la API de ${i?.name}?`)
};

const fr_seo_q_cost = /** @type {(inputs: Seo_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Combien coûte l’API ${i?.name} ?`)
};

const de_seo_q_cost = /** @type {(inputs: Seo_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Was kostet die ${i?.name}-API?`)
};

const ru_seo_q_cost = /** @type {(inputs: Seo_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Сколько стоит API ${i?.name}?`)
};

const it_seo_q_cost = /** @type {(inputs: Seo_Q_CostInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quanto costa l'API di ${i?.name}?`)
};

/**
* | output |
* | --- |
* | "How much does the {name} API cost?" |
*
* @param {Seo_Q_CostInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const seo_q_cost = /** @type {((inputs: Seo_Q_CostInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Q_CostInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_seo_q_cost(inputs)
	if (locale === "pt-BR") return pt_br2_seo_q_cost(inputs)
	if (locale === "es") return es_seo_q_cost(inputs)
	if (locale === "fr") return fr_seo_q_cost(inputs)
	if (locale === "de") return de_seo_q_cost(inputs)
	if (locale === "ru") return ru_seo_q_cost(inputs)
	if (locale === "it") return it_seo_q_cost(inputs)
	return en_seo_q_cost(inputs)
});